import React from 'react';

import {config, N8N} from "./index.js";
import { RouterContext } from "./router";
import { n8n } from "../lib/n8n";
import FileDrop from "./components/file-drop";
import Combobox from "./components/combobox";
import uri from "urijs";

export default function WireframePicker(props: { variant?: n8n.Variant, id?: n8n.ProjektNr }) {
	const n8n = React.useContext(N8N);
	const router = React.useContext(RouterContext);

	const customer = n8n.useCustomerProjects();

	const [id, setId] = React.useState(props.id ?? customer[0]?.projektnummer);
	const [variant, setVariant] = React.useState<n8n.Variant>(props.variant ?? 'A');

	const locateWireframe = React.useCallback(() => {
		router?.navigate(`/wireframe/fetch/${id}/${variant}`);
	}, [id, variant, router]);

	React.useEffect(() => {
		setId(props.id ?? customer[0]?.projektnummer);
		setVariant(props.variant ?? 'A');
	}, [props, customer]);

	const onDrop = React.useCallback((file: File) => {
		router?.navigate(`/wireframe/upload`, new Blob([file], {type: 'text/html'}));
	}, [router]);

	return <form action={locateWireframe} id="wireframe-picker">
		<article>
			<h1>Wireframe Editor</h1>
		</article>

			<label htmlFor="projekt-nr">Projekt Nummer</label>
			<span className='description'>
				Die Projektnummer kann hier frei angegeben werden.
				Existiert sie bereits noch nicht, wird eine neue angelegt
			</span>
			<Combobox values={customer.map(projekt => projekt.projektnummer)}
					  value={id}
					  onChange={e => setId(e as typeof id)}
					  id='projekt-nr' />

			<label htmlFor='variante'>Variante</label>
			<span className='description'>
				Wireframes existieren ausschließlich in 3 Varianten. Um eine neue anzulegen, muss eine existierende
				überschrieben werden
			</span>
			<div className='radio-slider widget' id='variante'>
				{['A', 'B', 'C']
					.map(i => <label key={`variant-${i}`}>
						{i}
						<input type='radio' name='variant' value={i} checked={variant == i} onChange={e => setVariant(e.currentTarget.value as typeof variant)} />
					</label>
				)}
			</div>

		<hr />

		<FileDrop onDrop={onDrop} accept={".html"}>
			<span data-icon={'\ueaf3'}>Wireframe Öffnen</span>
		</FileDrop>

		<nav>
			<button className='primary'>Edit</button>
		</nav>
	</form>;
}

export function WireframeFetch(props: { project: string, variant: string }) {
	const cx = React.useContext(RouterContext);

	React.useEffect(() => {
		const url = uri(config.kickoffUrl)
			.path(uri(config.kickoffUrl)
				.path()
				.split('/')
				.filter(i => !!i.trim())
				.concat(props.project, `wireframe-${props.variant.toLowerCase()}.html`)
				.join('/'));

		fetch(url.toString())
			.then(res => res.blob())
			.then(blob => cx?.navigate(`/wireframe/${props.project}/${props.variant}`, blob));
	}, [props.project, props.variant]);

	return <div id='wireframe-picker'>
		<span data-loading={true}>Lädt</span>
	</div>;
}